import { gql } from 'apollo-boost'

export const GET_STATEMENT = gql`
  query GetStatement($input: ListStatementsInput!) {
    listStatements(input: $input) {
      totalValue
      payedPercentage
      payedValue
      installmentsOpen {
        installmentId
        dueDate
        conditionDescription
        originalValue
        currentBalance
        interestPercent
        urlReport
        digitableNumber
        fineValue
        payedValue
        receivableBillId
      }
      installmentsOverdue {
        installmentId
        dueDate
        conditionDescription
        originalValue
        currentBalance
        interestPercent
        urlReport
        digitableNumber
        fineValue
        payedValue
        receivableBillId
      }
      installmentsComing {
        installmentId
        dueDate
        originalValue
        currentBalance
        conditionDescription
        receivableBillId
        interestPercent
      }
      installmentsPaid {
        installmentId
        dueDate
        conditionDescription
        currentBalance
        receipts {
          calculationDate
          receiptDate
          receiptValue
          interestValue
          additionalValue
          discountValue
        }
      }
    }
  }
`
